const mq = window.matchMedia("(min-width:750px)");

const getQueryString = function () {
  let query, params, i, element, name, value;
  let result = {};

  if (document.location.search.length === 0) {
    return result;
  }

  // 最初の1文字 (?記号) を除いた文字列を取得する
  query = document.location.search.substring(1);

  // クエリの区切り記号 (&) で文字列を配列に分割する
  params = query.split("&");

  for (i = 0; i < params.length; i++) {
    // パラメータ名とパラメータ値に分割する
    element = params[i].split("=");

    name = decodeURIComponent(element[0]);
    value = decodeURIComponent(element[1]);

    // パラメータ名をキーとして連想配列に追加する
    result[name] = decodeURIComponent(value);
  }

  return result;
};

const overviewSlider = (() => {
  const $stOverview = $(".pg-detail-overview");
  if ($stOverview.find(".swiper-slide").length > 1) {
    new Swiper($stOverview.find(".swiper-container"), {
      loop: true,
      loopedSlides: 10,
      navigation: {
        nextEl: $stOverview.find(".swiper-button-next"),
        prevEl: $stOverview.find(".swiper-button-prev"),
      },
      pagination: {
        el: $stOverview.find(".swiper-pagination"),
        type: "bullets",
      },
    });
  }
})();

const reviewSlider = (() => {
  const $target = $(".pg-review");
  new Swiper($target.find(".swiper-container"), {
    loop: true,
    loopedSlides: 10,
    navigation: {
      nextEl: $target.find(".swiper-button-next"),
      prevEl: $target.find(".swiper-button-prev"),
    },
    pagination: {
      el: $target.find(".swiper-pagination"),
      type: "bullets",
    },
  });
})();

// const reccomendSlider = (() => {
//   new Swiper($('.pg-detail-reccomend').find('.swiper-container'), {
//     loop: true,
//     freeMode: true,
//     speed: 7000,
//     centeredSlides: true,
//     // slidesPerView: 1,
//     slidesPerView: 'auto',
//     loopedSlides: 10,
//     autoplay: {
//       delay: 0,
//       disableOnInteraction: false
//     },
//     breakpoints: {
//       320: { // when window width is >= 320px
//         slidesPerView: 1.6,
//         spaceBetween: 16
//       },
//       768: {
//         slidesPerView: 3.2,
//         spaceBetween: 20
//       },
//       1000: {
//         slidesPerView: 5,
//         spaceBetween: 20
//       }
//     }
//     // slidesPerView: 5,
//     // spaceBetween: 40,
//     // centeredSlides: true,
//     // loop: true,
//     // breakpoints: {
//     //   768: {
//     //     slidesPerView: 2,
//     //     spaceBetween: 20,
//     //   }
//     // }
//   });
// })();

const mvSlider = (() => {
  const $mv = $(".pg-top-mv-slider");
  if ($mv.length === 0) return;
  const multiple = $mv.find(".swiper-slide").length > 1;
  const swiper = new Swiper($mv, {
    loop: multiple,
    speed: 800,
    slidesPerView: 1,
    autoplay: multiple
      ? {
          delay: 5000,
          disableOnInteraction: false,
        }
      : false,
    pagination: {
      el: $mv.find(".swiper-pagination"),
      type: "bullets",
      clickable: true,
    },
  });

  let isPlay = true;

  const toggle = document.querySelector("[data-mv-swiper-toggle]");
  toggle.addEventListener("click", () => {
    handleClick();
  });

  const handleClick = () => {
    if (isPlay) {
      swiper.autoplay.stop();
      toggle.setAttribute("aria-label", "スライドを再生");
    } else {
      swiper.autoplay.start();
      toggle.setAttribute("aria-label", "スライドを停止");
    }
    isPlay = !isPlay;
  };
})();

const newitemSlider = (() => {
  new Swiper($(".pg-top-newitem").find(".swiper-container"), {
    loop: true,
    freeMode: true,
    speed: 7000,
    centeredSlides: true,
    // slidesPerView: 1,
    slidesPerView: "auto",
    loopedSlides: 10,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        // when window width is >= 320px
        slidesPerView: 1.6,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 3.2,
        spaceBetween: 20,
      },
      1000: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
    // slidesPerView: 5,
    // spaceBetween: 40,
    // centeredSlides: true,
    // loop: true,
    // breakpoints: {
    //   768: {
    //     slidesPerView: 2,
    //     spaceBetween: 20,
    //   }
    // }
  });
})();

const pgTopSeriesSlider = (() => {
  new Swiper($(".pg-top-series").find(".swiper-container"), {
    slidesPerView: 1.4,
    pagination: {
      el: $(".pg-top-series").find(".swiper-pagination"),
      type: "bullets",
    },
    // mousewheel: {
    //   invert: false,
    // },
    breakpoints: {
      769: {
        slidesPerView: 3,
      },
      1000: {
        slidesPerView: 2,
      },
    },
  });
})();

const numberCounter = (() => {
  const $input = $(".pg-detail-overview-detail-add-counter-num");
  let value = 0;
  function set(flag) {
    /*
      flag true = increment
      flag false = decrement
    */
    if (flag) {
      if ($input.val() == "") {
        value = 1;
      } else {
        value = parseInt($input.val()) + 1;
      }
    } else {
      if (parseInt($input.val()) - 1 < 1) {
        value = 1;
      } else {
        value = parseInt($input.val()) - 1;
      }
    }
    $input.val(value);
  }
  $(".pg-detail-overview-detail-add-counter-minus").click(() => {
    set(false);
  });
  $(".pg-detail-overview-detail-add-counter-plus").click(() => {
    set(true);
  });
})();

const categoryAcordion = (() => {
  let isOpen = false;
  const $categoryList = $(".pg-category-list");
  const $categoryListBody = $(".pg-category-list-body");
  const speed = 300;

  function reset() {
    if (mq.matches) {
      $categoryList.removeClass("isOpen");
      $categoryListBody.removeAttr("style");
      isOpen = false;
    }
  }

  function open() {
    if (mq.matches) return;
    $categoryListBody.stop().slideDown(speed);
    $categoryList.addClass("isOpen");
    isOpen = true;
  }

  function close() {
    if (mq.matches) return;
    $categoryListBody.stop().slideUp(speed);
    $categoryList.removeClass("isOpen");
    isOpen = false;
  }

  $(".pg-category-list-header").click(() => {
    isOpen ? close() : open();
  });

  mq.addListener(reset);
})();

const nav = (() => {
  const html = document.documentElement;
  const $navBody = $(".navbody");
  let slider = null;

  function init() {
    if (slider == null) {
      slider = new Swiper($navBody.find(".swiper-container"), {
        slidesPerView: 1,
        spaceBetween: "10%",
        centeredSlides: true,
        loop: true,
        loopedSlides: 10,
        pagination: {
          el: $navBody.find(".swiper-pagination"),
          type: "bullets",
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        breakpoints: {
          768: {
            spaceBetween: 0,
          },
        },
      });
    }
  }

  function destroy() {
    if (slider != null) {
      slider.destroy();
      slider = null;
    }
  }

  document.querySelector(".nav-navtrigger").addEventListener("click", (e) => {
    e.preventDefault();
    if (html.classList.contains("isNavOpen")) {
      html.classList.remove("isNavOpen");
      setTimeout(destroy, 500);
    } else {
      html.classList.add("isNavOpen");
      html.classList.remove("isSearchOpen");
      init();
    }
  });

  document.querySelector(".header-search").addEventListener("click", (e) => {
    e.preventDefault();
    if (html.classList.contains("isSearchOpen")) {
      html.classList.remove("isSearchOpen");
    } else {
      html.classList.add("isSearchOpen");
      html.classList.remove("isNavOpen");
    }
  });

  document
    .querySelector(".header-search-body")
    .addEventListener("click", (e) => {
      if (!e.target.closest(".header-search-body-inner")) {
        html.classList.remove("isSearchOpen");
      }
    });
})();

const articleSort = (() => {
  const $select = $(".pg-info-result-sort-select");
  let currentURL = location.href;
  let query = getQueryString();
  // console.log(query)
  if (query && query.sort_by) {
    $select.val(query.sort_by);
  }
  $select.on("change", function () {
    let val = $(this).val();
    if (query && query.tag) {
      location.href =
        location.pathname + "?tag=" + query.tag + "&sort_by=" + val;
      // location.assign( location.pathname + "?tag="+ query.tag +"&sort_by=="+ val );
    } else {
      location.href = location.pathname + "?sort_by=" + val;
      // location.assign( location.pathname + "?sort_by=="+ val );
    }
  });
})();

const detailJancode = (() => {
  const $select = $(".pg-detail-overview-detail-color-selectwrap-select");
  if ($select[0] != undefined) {
    let val = null;
    let barcode = null;
    let $jancode_p = $(".pg-detail-overview-detail-jancode p");
    function setVal() {
      val = $select.val();
      barcode = document.querySelector('option[value="' + val + '"]').dataset
        .barcode;
      console.log(barcode);
      $jancode_p.text(barcode);
    }
    $select.on("change", setVal);
    setVal();
  }
})();

const productCategorySlider = (() => {
  const $target = $(".template-product .pg-detail-category-slider");
  new Swiper($target.find(".swiper-container"), {
    loop: true,
    // freeMode: true,
    // speed: 7000,
    centeredSlides: true,
    // slidesPerView: 1,
    slidesPerView: "auto",
    loopedSlides: 10,
    pagination: {
      el: $target.find(".swiper-pagination"),
      type: "bullets",
    },
    navigation: {
      nextEl: $target.find(".swiper-button-next"),
      prevEl: $target.find(".swiper-button-prev"),
    },
    on: {
      init: function () {
        // debugger;
        $target.attr("style", "opacity:1");
        let $btn = $target.find(".swiper-button-prev, .swiper-button-next");
        function adjust() {
          $btn.css({
            top:
              ($target.find(".pg-detail-category-slider-picture").height() -
                $btn.height()) /
              2,
          });
        }
        $(window).resize(adjust);
        setTimeout(function () {
          adjust();
        }, 500);
      },
    },
    breakpoints: {
      320: {
        // when window width is >= 320px
        slidesPerView: 1.6,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 3.2,
        spaceBetween: 20,
      },
      1000: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
    },
  });
})();

const crossSellRename = (() => {
  if (location.href.indexOf("/products/") != -1) {
    console.log("main.js");
    const $crossSell = $("#cross-sell");
    $crossSell.attr("style", "opacity:0");
    var timeoutTimer = "";
    var intervalTimer = setInterval(function () {
      if ($crossSell.find(".page-width").length != 0) {
        clearInterval(intervalTimer);
        clearTimeout(timeoutTimer);

        $crossSell.children("div").addClass("pg-detail-reccomend-slider");

        $crossSell
          .find(".page-width")
          .removeClass("page-width")
          .addClass("swiper-container")
          .children("div")
          .attr("class", "")
          .addClass("swiper-wrapper")
          .children("div")
          .attr("class", "")
          .addClass("swiper-slide")
          .parents(".swiper-container")
          .append(
            '<div class="swiper-button-next"></div><div class="swiper-button-prev"></div><div class="swiper-pagination"></div>',
          );

        // $crossSell
        //   .find("swiper-container").append("<div class=\"swiper-scrollbar\"></div>")

        new Swiper($crossSell.find(".swiper-container"), {
          loop: true,
          // freeMode: true,
          // speed: 7000,
          centeredSlides: true,
          // slidesPerView: 1,
          slidesPerView: "auto",
          loopedSlides: 10,
          pagination: {
            el: $crossSell.find(".swiper-pagination"),
            type: "bullets",
          },
          navigation: {
            nextEl: $crossSell.find(".swiper-button-next"),
            prevEl: $crossSell.find(".swiper-button-prev"),
          },
          on: {
            init: function () {
              $crossSell.attr("style", "opacity:1");
              let $btn = $crossSell.find(
                ".swiper-button-prev, .swiper-button-next",
              );
              function adjust() {
                $btn.css({
                  top:
                    ($crossSell
                      .find(".grid-view-item__image-wrapper")
                      .height() -
                      $btn.height()) /
                    2,
                });
              }
              $(window).resize(adjust);
              adjust();
            },
          },
          // autoplay: {
          //   delay: 0,
          //   disableOnInteraction: false
          // },
          breakpoints: {
            320: {
              // when window width is >= 320px
              slidesPerView: 1.6,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 3.2,
              spaceBetween: 20,
            },
            1000: {
              slidesPerView: 6,
              spaceBetween: 20,
            },
          },
          // slidesPerView: 5,
          // spaceBetween: 40,
          // centeredSlides: true,
          // loop: true,
          // breakpoints: {
          //   768: {
          //     slidesPerView: 2,
          //     spaceBetween: 20,
          //   }
          // }
        });
      }
    }, 500);

    timeoutTimer = setTimeout(function () {
      clearInterval(intervalTimer);
    }, 30000);
  }
})();

$(".sw-share-link-fb").click(() => {
  var set_url =
    "http://www.facebook.com/share.php?u=" + encodeURIComponent(location.href);
  window.open(
    set_url,
    "snsWindow",
    "width=650,height=450,menubar=no,toolbar=no,scrollbars=yes",
  );
  return false;
});

$(".sw-share-link-tw").click(() => {
  var set_text =
    document
      .querySelector('meta[name="twitter:description"]')
      .content.substring(0, 40) +
    "..." +
    "\r\n" +
    location.href;
  var set_url =
    "https://twitter.com/intent/tweet?text=" +
    encodeURIComponent(
      set_text.replace(/%%date%%/g, "?" + new Date().getDate()),
    ).replace(/brbr/g, "%0a");
  window.open(
    set_url,
    "snsWindow",
    "width=625,height=450,menubar=no,toolbar=no,scrollbars=yes",
  );
  return false;
});

// $('.sw-share-link-line').click(() => {
//   var set_url = 'http://line.me/R/msg/text/?' + location.href;
//   window.open(set_url, 'snsWindow', 'width=650, height=450, menubar=no, toolbar=no, scrollbars=yes');
//   return false;
// });

$(".sw-share-link-pinterest").click(() => {
  var set_url =
    "http://pinterest.com/pin/create/button/?url=" +
    location.href +
    "&media=" +
    document.querySelector('meta[property="og:image"]').content +
    "&description=" +
    document.querySelector('meta[property="og:description"]').content;
  window.open(
    set_url,
    "snsWindow",
    "width=650, height=450, menubar=no, toolbar=no, scrollbars=yes",
  );
  return false;
});

$(".st-info-header").on("click", function () {
  if ($(this).hasClass("isSlideOpen")) {
    $(this).removeClass("isSlideOpen").next().slideUp(300);
  } else {
    $(this).addClass("isSlideOpen").next().slideDown(300);
  }
});

const $pgDetailReview = $(".pg-detail-review");
$(".sw-review").on("click", () => {
  if ($pgDetailReview.length) {
    // debugger;
    const targetY = $pgDetailReview.offset().top;
    const navHeaderH = $(".navHeader").innerHeight();
    $("html,body").animate({ scrollTop: targetY - navHeaderH }, 500);
  }
});

const pgTopCategorySlider = (() => {
  new Swiper($(".pg-top-category").find(".swiper-container"), {
    slidesPerView: 2,
    slidesPerColumn: 2,
    slidesPerColumnFill: "row",
    spaceBetween: 20,
    pagination: {
      el: ".pg-top-category .swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    breakpoints: {
      769: {
        slidesPerView: 3,
      },
      1000: {
        slidesPerView: 4,
      },
    },
  });
})();

// 20260701
const pgTopPickSlider = (() => {
  const $container = $(".scn-top-pick .swiper-container");
  if (!$container.length) return;

  const $section = $("#scn-pick");
  if (!$section.length) return;

  new Swiper($container[0], {
    slidesPerView: 1.3,
    spaceBetween: 16,
    centeredSlides: false,
    pagination: {
      el: $section.find(".swiper-pick-pagination")[0],
      clickable: true,
    },
  });
})();

const pgCatePickSlider = (() => {
  const $container = $(".scn-cate-pick .swiper-container");
  if (!$container.length) return;

  const $section = $("#scn-pick");
  if (!$section.length) return;

  new Swiper($container[0], {
    slidesPerView: 1.3,
    spaceBetween: 16,
    centeredSlides: false,
    pagination: {
      el: $section.find(".swiper-pick-pagination")[0],
      clickable: true,
    },
  });
})();

/* 20260819 モバイル時スライダー化（イベント / お知らせ / ベストセラー） */
const pgEventSlider = (() => {
    const $container = $('.swiper-event');
    if (!$container.length) return;

    new Swiper($container[0], {
        slidesPerView: 2,
        spaceBetween: 16,
        centeredSlides: false,
        pagination: {
            el: $('.swiper-event-pagination')[0],
            clickable: true
        }
    });
})();

const pgNewsSlider = (() => {
    const $container = $('.swiper-news');
    if (!$container.length) return;

    new Swiper($container[0], {
        slidesPerView: 2,
        spaceBetween: 16,
        centeredSlides: false,
        pagination: {
            el: $('.swiper-news-pagination')[0],
            clickable: true
        }
    });
})();

const pgBestSellerSlider = (() => {
    const $container = $('.swiper-popularity-collection');
    if (!$container.length) return;

    new Swiper($container[0], {
        slidesPerView: 2,
        spaceBetween: 16,
        centeredSlides: false,
        pagination: {
            el: $('.swiper-popularity-collection-pagination')[0],
            clickable: true
        }
    });
})();